export const HIDE_LEFT_BAR = "HIDE_LEFT_BAR";
export const SHOW_LEFT_BAR = "SHOW_LEFT_BAR";